import React, { Component } from "react";
import { Modal, Select, Input, message, Spin } from "antd";
import SearchRetrieve from "../../common/SearchRetrieve.new";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";

const { Option } = Select;
const { TextArea } = Input;

let editRecord = null;

class DeptPendingModal extends Component {
    state = {
        visible: false,
        loading: false,
        submitting: false,
        params: {},
        courtyardList: [],
        courtyardMap: {},
        needCourtyard: false,
        courtyardDisabled: false,
    };

    show = (record) => {
        editRecord = record || null;
        const params = {
            hospitalId: record ? record.hospitalId : undefined,
            hospitalName: record ? record.hospitalName : undefined,
            courtyardArea: record ? record.courtyardArea : undefined,
            deptName: record ? record.deptName : undefined,
            remark: record ? record.remark : undefined,
            hospitalDeptPendingCooperationId: record ? record.hospitalDeptPendingCooperationId : undefined,
            hospitalPendingCooperationId: record ? record.hospitalId : undefined,
        };

        this.setState({
            visible: true,
            params,
            courtyardList: [],
            courtyardMap: {},
            needCourtyard: false,
            courtyardDisabled: false,
            submitting: false,
        }, () => {
            if (record && record.hospitalName) {
                this.queryCourtyardAreaList(record.hospitalName);
            }
        });
    };

    hide = () => {
        editRecord = null;
        this.setState({
            visible: false,
            courtyardList: [],
            courtyardMap: {},
            needCourtyard: false,
            courtyardDisabled: false,
        });
    };

    queryCourtyardAreaList = (hospitalName) => {
        if (!hospitalName) return;
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.pendingCooperationCourtyardListForAdd,
            data: { limit: 50, offset: 1, equHospitalName: hospitalName },
            dataType: 'json',
            doneResult: res => {
                const datas = res.datas || [];
                const courtyardMap = {};
                datas.forEach(i => {
                    if (i.courtyardArea) {
                        courtyardMap[i.courtyardArea] = i.hospitalPendingCooperationId;
                    }
                });
                const courtyardAreas = Object.keys(courtyardMap);
                const hasCourtyard = courtyardAreas.length > 0;

                let courtyardDisabled = false;
                const { params } = this.state;

                // 如果只有一个院区，默认选中且不可编辑
                if (courtyardAreas.length === 1 && !params.courtyardArea) {
                    params.courtyardArea = courtyardAreas[0];
                    params.hospitalPendingCooperationId = courtyardMap[courtyardAreas[0]];
                    courtyardDisabled = true;
                } else if (courtyardAreas.length === 0 && datas.length === 1 && !datas[0].courtyardArea) {
                    // 无院区但只有一条记录，直接取该条记录的ID
                    params.hospitalPendingCooperationId = datas[0].hospitalPendingCooperationId;
                    courtyardDisabled = true;
                }

                this.setState({
                    courtyardList: datas,
                    courtyardMap,
                    needCourtyard: hasCourtyard,
                    courtyardDisabled,
                    params,
                });
            }
        });
    };

    submit = () => {
        const { params } = this.state;
        const { deptName, hospitalPendingCooperationId } = params;
        if (!hospitalPendingCooperationId) { message.warning("请选择医院"); return; }
        if (!deptName || !deptName.trim()) { message.warning("请输入科室名称"); return; }

        this.setState({ submitting: true });
        const url = editRecord
            ? API_URL.hospital.deptPendingCooperationUpdate
            : API_URL.hospital.deptPendingCooperationAdd;
        const submitData = {
            hospitalId: hospitalPendingCooperationId,
            deptName: deptName.trim(),
            remark: params.remark,
        };
        if (editRecord) {
            submitData.hospitalDeptPendingCooperationId = params.hospitalDeptPendingCooperationId;
        }

        $.sendRequest({
            method: "POST",
            url,
            data: submitData,
            dataType: "json",
            doneResult: (res) => {
                message.success(editRecord ? "修改成功" : "新增成功");
                this.setState({ submitting: false }, () => { this.hide(); this.props.loadData(); });
            },
            errorResult: () => { this.setState({ submitting: false }); },
        });
    };

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    };

    handleCourtyardChange = (value) => {
        const { params, courtyardMap } = this.state;
        params.courtyardArea = value;
        if (courtyardMap && courtyardMap[value]) {
            params.hospitalPendingCooperationId = courtyardMap[value];
        }
        this.setState({ params });
    };

    handleHospitalChange = (options) => {
        const { params } = this.state;
        // listForAdd 接口返回的 value 和 text 都是 hospitalName（不返回ID）
        params.hospitalName = options.text;
        params.hospitalPendingCooperationId = undefined; // 将在选择院区后确定
        params.courtyardArea = undefined;
        this.setState({
            params,
            courtyardList: [],
            courtyardMap: {},
            needCourtyard: false,
            courtyardDisabled: false,
        }, () => {
            if (options.text) { this.queryCourtyardAreaList(options.text); }
        });
    };

    getContent = () => {
        const { params, visible, courtyardList, needCourtyard, courtyardDisabled } = this.state;
        const { hospitalName, courtyardArea, deptName, remark } = params;
        const asterisk = <span style={{ color: "red" }}>*</span>;

        const courtyardOptions = Object.keys(this.state.courtyardMap).map(ca =>
            <Option key={ca} value={ca}>{ca}</Option>
        );

        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}医院:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <SearchRetrieve
                                keyword="hospitalName"
                                style={{ width: 260 }}
                                params={{ limit: 10, offset: 1 }}
                                placeholder="输入医院名称检索"
                                url={API_URL.hospital.pendingCooperationListForAdd}
                                value={hospitalName}
                                config={{ id: 'hospitalName', name: 'hospitalName' }}
                                onChange={this.handleHospitalChange}
                            />
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>院区:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            needCourtyard ? (
                                <Select
                                    allowClear={true}
                                    style={{ width: 260 }}
                                    placeholder="请选择院区"
                                    disabled={courtyardDisabled}
                                    value={courtyardArea}
                                    onChange={this.handleCourtyardChange}
                                >
                                    {courtyardOptions}
                                </Select>
                            ) : (
                                <Input
                                    style={{ width: 260 }}
                                    placeholder="无院区"
                                    disabled
                                    value=""
                                />
                            )
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}科室:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <Input
                                style={{ width: 260 }}
                                placeholder="请输入科室名称"
                                value={deptName}
                                onChange={e => this.handleInputChange(e, 'deptName')}
                            />
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>备注:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <TextArea
                                value={remark}
                                maxLength="200"
                                placeholder="请输入"
                                style={{ width: 220, height: 80 }}
                                onChange={e => this.handleInputChange(e, "remark")}
                            />
                        )}
                    </div>
                </li>
            </ul>
        );
    };

    render() {
        const { visible, submitting } = this.state;
        return (
            <Modal
                title={`${editRecord ? "修改" : "新增"}待合作医院科室`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={submitting}
                maskClosable={false}
                width="620px"
            >
                <Spin spinning={submitting}>
                    <div className="modal-content" style={{ padding: "0 20px" }}>{this.getContent()}</div>
                </Spin>
            </Modal>
        );
    }
}

export default DeptPendingModal;



// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/DeptPendingModal.js